export const config = {
    appname: 'devapp',
    app_id: '2439493236332961', // App ID
    facebook_app_id: '2439493236332961', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'stg',
    bzbsUrl: 'https://api1servicecenter.buzzebees-uat.com',
    bzbsModuleUrl: 'https://apimodule.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice.buzzebees-uat.com',
    bzbsBlobUrl: 'https://stgstoragebuzzebees.blob.core.windows.net',
    miscUrl: 'https://misc.buzzebees-uat.com',
    // ------------------ End Settings ---------------------

    // --------------------- Recaptcha ---------------------
    recaptchaSiteKey: "6LeSnaAmAAAAAM8nTr70vcd-gBwNnrv06XjpZz-6",

    webApi: '',

    firebase: {
        // apiKey: "",
        // authDomain: "",
        // databaseURL: "",
        // projectId: "",
        // storageBucket: "",
        // messagingSenderId: "",
        // appId: "",
        // measurementId: ""
    },
};
